<div id="lot-fit-container">
  <div class="svg-container" #svgContainer></div>
  <div class="right-lot-fit-content">
    <div class="favorites-container">
      <favorite-btn [isActive]="isFavorited" (toggle)="handleFavsToggle()"></favorite-btn>
    </div>
    @for(fp of floorplans; track fp.FloorplanId) {
    <accordion [isOpen]="fp.FloorplanId === selectedFloorplan.FloorplanId" [ariaLabel]="'Lot Fit options for ' + fp.Name" [controlInternally]="false"
               (isOpenChanged)="fp.FloorplanId === selectedFloorplan.FloorplanId ? null : setInitLotFitSelections(fp)">
      <div header>
        <icon name="floorplan"></icon>
        <h2>{{fp.Name}}</h2>
      </div>
      <div body>
        <div class="lot-fit-content">
          <gallery [images]="fp.ElevationGalleryImages" [displayedImageOverrideId]="displayedImageOverride" [showFavoriteBtn]="false"
                   [showFullscreenBtn]="false" (imageChange)="handleElevationChangeFromGallery($event)">
          </gallery>
          <div id="lot-fit-options-container">
            <div class="lot-fit-selection-group">
              <h4>Select Exterior Elevation</h4>
              @for(elevation of selectedFloorplan.Elevations; track elevation.ElevationId) {
              <div class="lot-fit-selection">
                <input id="elevation-{{elevation.ElevationId}}" name="elevation-{{elevation.ElevationId}}" type="radio"
                       [ngModel]="selectedElevation.ElevationId" (ngModelChange)="handleElevationSelect(elevation)" [value]="elevation.ElevationId" />
                <label class="radio-label" for="elevation-{{elevation.ElevationId}}">{{elevation.Title}}</label>
              </div>
              }
            </div>
            @if(fp.GarageSwings.left || fp.GarageSwings.right) {
            <div class="lot-fit-selection-group">
              <h4>Garage Swing</h4>
              @if(fp.GarageSwings.left) {
              <div class="lot-fit-selection">
                <input id="swing-{{'L'}}" name="swing-{{'L'}}" type="radio" [ngModel]="selectedSwing" [value]="'L'"
                       (ngModelChange)="handleSwingSelect('L')" />
                <label class="radio-label" for="swing-{{'L'}}">Left</label>
              </div>
              }
              @if(fp.GarageSwings.right) {
              <div class="lot-fit-selection">
                <input id="swing-{{'R'}}" name="swing-{{'R'}}" type="radio" [ngModel]="selectedSwing" [value]="'R'"
                       (ngModelChange)="handleSwingSelect('R')" />
                <label class="radio-label" for="swing-{{'R'}}">Right</label>
              </div>
              }
            </div>
            }

          </div>
        </div>
      </div>
    </accordion>
    }
  </div>
</div>